<template>
  <div>
    <div class="note" :key="stat.id" v-for="stat in stats">
      <StatResources v-if="stat.resources" :payload="{ stat }"></StatResources>
      <p dir="rtl" class="mb-0">
        <b>{{ stat.owner }}</b> (<b>{{
          $moment(stat.created_at).format('DD/MM/YYYY')
        }}</b
        >):
      </p>
      <p v-html="$sanitize(stat.content)" class="white_space_pre_line break_word"></p>
    </div>
  </div>
</template>

<script>
import StatResources from '@/components/StatResources'

export default {
  name: 'ModalAdminStats',
  components: {
    StatResources
  },
  props: {
    initialStat: {
      type: Object
    }
  },
  data () {
    return {
      stats: []
    }
  },
  created () {
    this.getStats()
  },
  methods: {
    getStats () {
      this.$network_utils
        .getStats({
          time_exceeded_resource_id: this.initialStat.resource_id,
          time_exceeded_id: this.initialStat.id,
          owner: this.initialStat.owner
        })
        .then((response) => {
          this.stats = response
        })
    }
  }
}
</script>

<style scoped>
.note {
  margin-bottom: 10px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.18);
}
</style>
